var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAllMentorListButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.57,
    y1: 100.83,
    x2: 153.6,
    y2: -18.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9afd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#cea9cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#af98c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#998bc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#8c84be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8781bd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1._STARTUPNEWAPPLICATIONS",
    "data-name": "1. STARTUPNEWAPPLICATIONS"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 194,
    height: 88,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.85,
    y: 5.54,
    width: 176.47,
    height: 71.56,
    rx: 8.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.45,37.19,55,23.71h1.88L59,30.35c.58,1.82,1.08,3.46,1.45,5h0c.38-1.56.94-3.26,1.54-5l2.28-6.66h1.86L61.37,37.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.39,23.71V37.19H67.64V23.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.41,30.87H74.17v4.86H80v1.46H72.43V23.71h7.28v1.46H74.17v4.26h5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.64,37.19,81.22,23.71h1.84l1.61,6.82c.39,1.68.76,3.36,1,4.66h0c.22-1.34.64-2.94,1.09-4.68l1.81-6.8h1.82l1.64,6.84c.38,1.6.74,3.2.94,4.62h0c.28-1.48.66-3,1.08-4.66l1.78-6.8h1.78L93.87,37.19H92.05l-1.7-7a40.59,40.59,0,0,1-.88-4.4h0a42.11,42.11,0,0,1-1,4.4l-1.92,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.78,33l-1.4,4.24h-1.8l4.58-13.48h2.1l4.61,13.48H112L110.56,33Zm4.43-1.36-1.32-3.88c-.31-.88-.5-1.68-.71-2.46h0c-.2.8-.42,1.62-.68,2.44l-1.32,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.84,23.71h1.74v12h5.77v1.46h-7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.28,23.71H127v12h5.76v1.46h-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.4,51.27c-.1-1.88-.22-4.14-.2-5.82h-.06c-.46,1.58-1,3.26-1.7,5.12l-2.38,6.54H40.74l-2.19-6.42c-.63-1.9-1.18-3.64-1.56-5.24h0c0,1.68-.14,3.94-.26,6l-.36,5.78H34.67l.94-13.48h2.23l2.3,6.52c.56,1.66,1,3.14,1.36,4.54h.06c.34-1.36.82-2.84,1.42-4.54l2.4-6.52H47.6l.84,13.48h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.1,50.87H52.85v4.86H58.7v1.46H51.11V43.71H58.4v1.46H52.85v4.26H58.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61,57.19V43.71h1.9l4.33,6.82a38.16,38.16,0,0,1,2.42,4.38l0,0c-.16-1.8-.2-3.44-.2-5.54V43.71h1.64V57.19H69.32L65,50.35a42.92,42.92,0,0,1-2.53-4.5l-.06,0c.1,1.7.15,3.32.15,5.56v5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.67,45.19h-4.1V43.71h10v1.48H78.43v12H76.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95,50.31c0,4.64-2.82,7.1-6.27,7.1s-6.06-2.76-6.06-6.84c0-4.28,2.66-7.08,6.26-7.08S95,46.31,95,50.31Zm-10.47.22c0,2.88,1.56,5.46,4.31,5.46s4.32-2.54,4.32-5.6c0-2.68-1.4-5.48-4.31-5.48S84.57,47.57,84.57,50.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.29,43.89a18.12,18.12,0,0,1,3.34-.28,5.51,5.51,0,0,1,3.9,1.1,3.33,3.33,0,0,1,1.07,2.56,3.55,3.55,0,0,1-2.55,3.44v.06a3.34,3.34,0,0,1,2,2.72,22.45,22.45,0,0,0,1,3.7h-1.8a17.46,17.46,0,0,1-.9-3.22c-.4-1.86-1.12-2.56-2.7-2.62H99v5.84H97.29ZM99,50h1.78c1.86,0,3-1,3-2.56,0-1.74-1.26-2.5-3.1-2.52a7.16,7.16,0,0,0-1.72.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.81,55.07a6.17,6.17,0,0,0,3.12.88c1.79,0,2.83-.94,2.83-2.3s-.73-2-2.55-2.68c-2.2-.78-3.56-1.92-3.56-3.82,0-2.1,1.74-3.66,4.36-3.66a6.2,6.2,0,0,1,3,.66l-.49,1.42a5.3,5.3,0,0,0-2.56-.64c-1.84,0-2.54,1.1-2.54,2,0,1.26.82,1.88,2.69,2.6,2.28.88,3.44,2,3.44,4s-1.54,3.88-4.73,3.88a7,7,0,0,1-3.44-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.15,43.71h1.74v12h5.76v1.46h-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.33,43.71V57.19h-1.74V43.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.13,55.07a6.17,6.17,0,0,0,3.12.88c1.78,0,2.82-.94,2.82-2.3s-.72-2-2.54-2.68c-2.2-.78-3.56-1.92-3.56-3.82,0-2.1,1.74-3.66,4.36-3.66a6.12,6.12,0,0,1,3,.66l-.48,1.42a5.37,5.37,0,0,0-2.56-.64c-1.84,0-2.54,1.1-2.54,2,0,1.26.82,1.88,2.68,2.6,2.28.88,3.44,2,3.44,4s-1.54,3.88-4.72,3.88a7,7,0,0,1-3.44-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.79,45.19h-4.1V43.71h10v1.48h-4.12v12h-1.76Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllMentorListButton);
export default __webpack_public_path__ + "static/media/viewAllMentorListButton.7b83d34b3522490e48ccb7f525d19e8a.svg";
export { ForwardRef as ReactComponent };